import type { IconSvgObject } from './types';

const FilePoundIcon: IconSvgObject = [
  ["path", { d: "M11.5 22.0015H5C3.89543 22.0015 3 21.1061 3 20.0015V9.81667C3 9.28553 3.21128 8.7762 3.58724 8.40101L9.41585 2.58434C9.7908 2.21015 10.2989 2 10.8286 2H18C19.1046 2 20 2.89543 20 4V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 9.00146H8C9.10457 9.00146 10 8.10603 10 7.00146V2.00146", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 22H15C16.1046 22 17 21.1046 17 20V16C17 14.8954 17.8954 14 19 14C20.1046 14 21 14.8954 21 16M15 19H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FilePoundIcon;
